import { useEffect } from 'react'

export const FIELD_ERROR_CLASS = 'field-error'

export const useScrollToFieldError = (formik: { submitCount: number }) => {
  useEffect(() => {
    const el = document.querySelector<HTMLDivElement>(
      `div.${FIELD_ERROR_CLASS}`
    )
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [formik.submitCount])
}
